import React from 'react';
import Grid from '@material-ui/core/Grid'
import { makeStyles } from '@material-ui/core/styles';
//import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';

import Avatar from '@material-ui/core/Avatar';
//import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
//import MoreVertIcon from '@material-ui/icons/MoreVert';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
//import EmailIcon from '@material-ui/icons/Email';
import LocalAtmIcon from '@material-ui/icons/LocalAtm';
//import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import PropTypes from 'prop-types';
//import AddIcon from '@material-ui/icons/Add';
import Skeleton from '@material-ui/lab/esm/Skeleton';
import { Box, TextField, Divider } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
//import Footer from '../Complements/Footer';
// import Title from './../Complements/Title';
//import VoucherTransfersMobile from './VoucherTransfersMobile';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
//import AddIcon from '@material-ui/icons/Add';
//import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import moment from 'moment'
import VoucherTransfersWeb from './VoucherTransfersWeb';
import { IconButton } from '@mui/material';
import { AccountCircle, Add, ArrowBackIos } from '@mui/icons-material';
import { history } from '../../helpers/history';
import { useSelector } from 'react-redux';


const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
    },
    root2: {
        backgroundColor: theme.palette.background.paper,
        width: 500,
        position: 'relative',
        minHeight: 300,
    },
    paper: {
        height: 500,
        width: 400,
    },
    control: {
        padding: theme.spacing(2),
    },
    card: {
        height: 500,
        width: 400,
        maxWidth: 345,
        backgroundColor: "#EEEFF2"
    },
    card2: {
        height: 100,
        width: 100,
        maxWidth: 345,
    },
    media: {
        height: 0,
        paddingTop: '56.25%', // 16:9
    },
    expand: {
        transform: 'rotate(0deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
    },
    expandOpen: {
        transform: 'rotate(180deg)',
    },
    avatar: {
        backgroundColor: '#b98919',
        marginTop: '0px'
    },
    fab: {
        position: 'absolute',
        bottom: theme.spacing(5),
        right: theme.spacing(2),
    },
    rowIcon: {
        top: '40%'
    },
    titleDark: {
        // color: '#000000',
        fontWeight: 'bold',
        fontSize: '0.875rem',
        //fontFamily: 'MyriadPro-Bold'
    },
    titleLight: {
        // color: '#000000',
        fontSize: '0.875rem',
        //fontFamily: 'MyriadPro-SemiBold',
        fontWeight: 'bold',
    },
    titleGreenBlackPrimary: {
        color: '#b98919',
        fontSize: '1.05rem',
        //fontFamily: 'MyriadPro-Bold'
    },
    titleGreenBlackSecondary: {
        // color: '#000000',
        fontSize: '1rem',
        //fontFamily: 'MyriadPro-SemiBold'
    },
    divStandard: {
        //margin: "20px",
        padding: "20px",
        backgroundColor: theme.palette.type === 'dark' ? '#4a4a4a' : '#fafafa',
        // border: '2px solid #BEBCC0',

        borderRadius: "8px",
        // boxShadow: '4px 4px 4px 0px rgba(46,46,46,0.75)'
    }
}));


const Transfers = props => {
    const classes = useStyles();
    const { user, openBeneficiaryList, beneficiarySelected, transferForm, dialogOTP, tittle,
        openDialogBeneficiaryForm, balances, accountSelected, changeAccount, isviewvoucher, responseservertransfer, handleDownloadVoucher,
        handleDownloadDevice, handleConvertMask, resetviewtransfert, typeBeneficiaries, /*beneficiaries,*/ handleSendEmailWithVoucher } = props
    const { user: owner, name, type_name, number } = beneficiarySelected
    const { monto, numeroCuentaDestino, fecha, numeroCuentaOrigen, tipoCuentaOrigen, nombreBeneficiario, tipoCuentaDestino,
        institucion, comision, concepto, dispositivo, numeroMensajeTransaccion, nombreCliente } = responseservertransfer;
    const permissions = useSelector(state => state.permissions)
    return (
        <div>
            <Typography><IconButton onClick={() => history.push("/")} style={{ marginRight: "8px" }}><ArrowBackIos /></IconButton>{tittle}</Typography>
            <Grid container className={classes.root} justifyContent="center" alignItems="center">
                <Grid item xs={12}>
                    <Grid container spacing={3} style={{ padding: '20px' }}>
                        <Grid item xs={12} md={6} lg={6} >
                            {/* <Title>Ordenante</Title> */}
                            <div className={classes.divStandard}>
                                <List className={classes.root}>
                                    <ListItem alignItems="center">
                                        <ListItemAvatar>
                                            <Avatar aria-label="recipe" className={classes.avatar}>
                                                {user ? (user.ClientType === 1) ? user.FirstName.charAt(0) : user.Name.charAt(0) : <Skeleton variant="circle" width={40} height={40} />}
                                            </Avatar>
                                        </ListItemAvatar>
                                        <ListItemText
                                            primary={
                                                <span className={classes.titleDark}>
                                                    {
                                                        user ?
                                                            user.Name :
                                                            <Skeleton height={10} width="80%" style={{ marginBottom: 6 }} />
                                                    }
                                                </span>
                                            } secondary={
                                                <>
                                                    <span className={classes.titleLight}>
                                                        {
                                                            balances ? `${accountSelected.PRODUCTALIAS}` : <Skeleton height={10} width="40%" />
                                                        }
                                                    </span>
                                                    <br></br>
                                                    <span className={classes.titleLight}>
                                                        {
                                                            balances ? `${handleConvertMask(accountSelected.PRODUCTBANKID)}` : <Skeleton height={10} width="40%" />
                                                        }
                                                    </span>
                                                </>
                                            }
                                        />
                                    </ListItem>
                                </List>
                                <Divider></Divider>
                                <br></br>
                                <Autocomplete
                                    id="combo-box-demo"
                                    className={classes.titleLight}
                                    value={accountSelected}
                                    options={balances}
                                    onChange={(e, nv) => {
                                        changeAccount(nv)
                                    }}
                                    disableClearable
                                    getOptionLabel={(option) => `${handleConvertMask(option.PRODUCTBANKID)} - ${option.PRODUCTALIAS}`}
                                    renderOption={(option) => (
                                        <React.Fragment>
                                            {`${handleConvertMask(option.PRODUCTBANKID)} - ${option.PRODUCTALIAS}`}
                                        </React.Fragment>
                                    )}
                                    renderInput={(params) => <TextField {...params} label="Seleccione una cuenta" variant="outlined" fullWidth />}
                                />
                                <br></br>
                                <Divider></Divider>
                                {
                                    user ?
                                        <List className={classes.root}>
                                            <ListItem >
                                                <ListItemAvatar >
                                                    <Avatar style={{ color: '#2E2757', backgroundColor: '#EEEFF2' }}>
                                                        {user ? <LocalAtmIcon /> : <Skeleton variant="circle" width={40} height={40} />}
                                                    </Avatar>
                                                </ListItemAvatar>
                                                {
                                                    user ?
                                                        <ListItemText

                                                            primary={
                                                                <span className={classes.titleGreenBlackSecondary}>
                                                                    Saldo Disponible
                                                                </span>
                                                            }
                                                            secondary={
                                                                <span className={classes.titleGreenBlackPrimary}>
                                                                    {(permissions.includes(11) ?  `$ ${accountSelected.SALDOINT}` : '*****.**')}
                                                                </span>
                                                            } /> :
                                                        <ListItemText
                                                            primary={<Skeleton variant="text" />}
                                                            secondary={<Skeleton variant="text" />} />
                                                }

                                            </ListItem>
                                            <ListItem >
                                                <ListItemAvatar>
                                                    <Avatar style={{ color: '#2E2757', backgroundColor: '#EEEFF2' }}>
                                                        {user ? <MailOutlineIcon /> : <Skeleton variant="circle" width={40} height={40} />}
                                                    </Avatar>
                                                </ListItemAvatar>
                                                {
                                                    user ?
                                                        <ListItemText
                                                            primary={<span className={classes.titleGreenBlackSecondary}>
                                                                Correo Electrónico
                                                            </span>}

                                                            secondary={<span className={classes.titleGreenBlackSecondary}>
                                                                {user.Mail}
                                                            </span>} /> :
                                                        <Box pt={0.5}>
                                                            <Skeleton />
                                                            <Skeleton width="60%" />
                                                        </Box>
                                                }

                                            </ListItem>
                                        </List> :
                                        <div>
                                            <CardHeader
                                                avatar={
                                                    <Avatar aria-label="recipe" >
                                                        <Skeleton variant="circle" width={40} height={40} />
                                                    </Avatar>
                                                }
                                                title={<Skeleton height={10} width="80%" style={{ marginBottom: 6 }} />}
                                                subheader={<Skeleton height={10} width="40%" />}
                                            />
                                            <CardHeader
                                                avatar={
                                                    <Avatar aria-label="recipe" >
                                                        <Skeleton variant="circle" width={40} height={40} />
                                                    </Avatar>
                                                }
                                                title={<Skeleton height={10} width="80%" style={{ marginBottom: 6 }} />}
                                                subheader={<Skeleton height={10} width="40%" />}
                                            />
                                        </div>
                                }
                            </div>
                        </Grid>
                        <Grid item xs={12} md={6} lg={6} >
                            <div className={classes.divStandard}>
                                <Typography>Beneficiario</Typography>
                                {(isviewvoucher === false) ?

                                    <React.Fragment>
                                        {(beneficiarySelected.user) && <List className={classes.root}>
                                            <ListItem alignItems="flex-start">
                                                <ListItemAvatar>
                                                    <Avatar aria-label="recipe" className={classes.avatar}>
                                                        {owner ? name.charAt(0) : 'SN'}
                                                    </Avatar>

                                                </ListItemAvatar>
                                                <ListItemText
                                                    primary={owner ? name : 'Seleccione un beneficiario'}
                                                    secondary={owner ? `${type_name} - ${handleConvertMask(number)}` : '---'}
                                                />
                                            </ListItem>
                                        </List>}

                                        <Typography variant="body2" color="textSecondary" component="p"></Typography>
                                        {owner ?
                                            transferForm
                                            :
                                            <List className={classes.root}>
                                                <ListItem button name="transfer_select_beneficiary" onClick={() => openBeneficiaryList()} >
                                                    <ListItemAvatar>
                                                        <Avatar aria-label="recipe" style={{ backgroundColor: '#b98919' }}>
                                                            <AccountCircle />
                                                        </Avatar>
                                                    </ListItemAvatar>
                                                    <ListItemText primary={(typeBeneficiaries !== "PROPIA") ? "Seleccione Beneficiario" : "Seleccionar una Cuenta"} secondary="" />
                                                </ListItem>
                                                {(typeBeneficiaries !== "PROPIA" && permissions.includes(3)) && <ListItem button name="transfer_add_beneficiary" onClick={() => openDialogBeneficiaryForm()} >
                                                    <ListItemAvatar>
                                                        <Avatar aria-label="recipe" style={{ backgroundColor: '#b98919' }}>
                                                            <Add />
                                                        </Avatar>
                                                    </ListItemAvatar>
                                                    <ListItemText primary={"Agregar Nuevo Beneficiario"} secondary="" />
                                                </ListItem>}
                                            </List>
                                        }
                                    </React.Fragment>

                                    :
                                    <VoucherTransfersWeb
                                        title={"TRANSFERENCIA EXITOSA"}
                                        titleone={"DATOS EMISOR"}
                                        viewVoucher={false}
                                        databodyone={[
                                            {
                                                title: "Nombres",
                                                value: nombreCliente,
                                                order: 1
                                            },
                                            {
                                                title: "Cuenta",
                                                value: handleConvertMask(numeroCuentaOrigen),
                                                order: 2
                                            },
                                            {
                                                title: "Fecha",
                                                value: moment(fecha).format("YYYY-MM-DD"),
                                                order: 3
                                            },
                                            {
                                                title: "Concepto",
                                                value: concepto,
                                                order: 4
                                            },
                                            {
                                                title: "Dcto. de trans",
                                                value: numeroMensajeTransaccion,
                                                order: 5
                                            },
                                            {
                                                title: "Comisión",
                                                value: "$ " + parseFloat(comision).toFixed(2),
                                                order: 9
                                            }
                                        ]}
                                        titletwo={"DATOS BENEFICIARIO"}
                                        databodytwo={[
                                            {
                                                title: "Nombres",
                                                value: nombreBeneficiario,
                                                order: 1
                                            },
                                            {
                                                title: "Cuenta",
                                                value: handleConvertMask(numeroCuentaDestino),
                                                order: 2
                                            },
                                            {
                                                title: "Institución",
                                                value: institucion,
                                                order: 3
                                            },
                                        ]}
                                        nombreCliente={(user.ClientType === false) ? user.razonSocial : user.nombres + " " + user.apellidos}
                                        numeroCuentaOrigen={handleConvertMask(numeroCuentaOrigen)}
                                        tipoCuentaOrigen={tipoCuentaOrigen}
                                        nombreBeneficiario={nombreBeneficiario}
                                        numeroCuentaDestino={handleConvertMask(numeroCuentaDestino)}
                                        tipoCuentaDestino={tipoCuentaDestino}
                                        institucion={institucion}
                                        monto={monto}
                                        comision={comision}
                                        concepto={concepto}
                                        fecha={fecha}
                                        dispositivo={dispositivo}
                                        typesizegrid={6}
                                        handleDownloadVoucher={handleDownloadVoucher}
                                        handleDownloadDevice={handleDownloadDevice}
                                        resetviewtransfert={resetviewtransfert}
                                        handleSendEmailWithVoucher={handleSendEmailWithVoucher}
                                    />
                                }
                            </div>
                        </Grid>
                    </Grid>
                    {/* <Footer /> */}
                </Grid>
            </Grid>
            {dialogOTP}
        </div>
    );
};

Transfers.propTypes = {
    user: PropTypes.object.isRequired,
};

export default Transfers;
